export default __webpack_public_path__ + "static/media/kDLmyNEnoU.b554fc29.jpg";